/**
 * Ensure external links open new window
 *
 * External Domain Regex Check
 * http://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
 */
function isExternalDomain(url) {
  let domainRe = /https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/i

  function domain(url) {
    let results = domainRe.exec(url)
    if (results && results.length) {
      return results[1]
    }
    return false
  }

  return domain(location.href) !== domain(url)
}

function targetBlank() {
  'use strict'
  let elements = document.querySelectorAll('a[href]:not([href=""])')
  let elementCount = elements.length
  for (let e = 0; e < elementCount; ++e) {
    if (isExternalDomain(elements[e].href)) {
      elements[e].setAttribute('target', '_blank')
    }
  }
}

targetBlank()
